import React, { ReactElement } from "react";
import Link from "next/link";
import WhatsappIcon from "@icons/whatsappIconV2.svg";
import { Phone, MessageQuestionCircle, Mail01 } from "@untitled-ui/icons-react";
import styles from "./contactOptions.module.scss";

export const HeaderContactOptions = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        <div className={styles.alignment}>
          {props.firstLabel && props.firstUrl && (
            <Link href={props.firstUrl} className={styles.link} target="_blank">
              <WhatsappIcon width="20" height={20} />
              {props.firstLabel}
            </Link>
          )}
          {props.secondLabel && props.secondUrl && (
            <Link href={props.secondUrl} className={styles.link}>
              <Phone viewBox="0 0 24 24" width={20} height={20} />
              {props.secondLabel}
            </Link>
          )}
        </div>
        <div className={styles.alignment}>
          {props.thirdLabel && props.thirdUrl && (
            <Link href={props.thirdUrl} className={styles.link}>
              <MessageQuestionCircle
                viewBox="0 0 24 24"
                width="20"
                height={20}
              />
              {props.thirdLabel}
            </Link>
          )}
          {props.forthLabel && props.forthUrl && (
            <Link href={props.forthUrl} className={styles.link}>
              <Mail01 viewBox="0 0 24 24" width={20} height={20} />
              {props.forthLabel}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

interface Props {
  firstLabel?: string;
  firstUrl?: string;
  secondLabel?: string;
  secondUrl?: string;
  thirdLabel?: string;
  thirdUrl?: string;
  forthLabel?: string;
  forthUrl?: string;
}
